<ng-container>
    <div class="logout">
        <div class="logout-detail">
            <div class="ey-logo">
                <img motif-header-logo alt="PM Pro" src='assets/images/ey-container-logo.svg' position="left">
                <div class="brand">
                    <p class="brand-name">{{moduleName}}</p>
                </div>
            </div>
            <img class="logout-image mr-1" src="assets/images/logout/group.svg" alt="group" />
            <div class="logout-details">
                <img class="frame frame_start mb-2 ml-2" src="assets/images/logout/frame.svg" alt="frame" />
                <div class="logout-content">
                    <h2 class="text"> {{'logutExpirationMessage' | translate}}</h2>
                    <p class="text">{{'ClickHereToLogin' | translate}}</p>
                    <button motifButton color="primary-alt" (click)="login()">{{'Login' | translate}}</button>
                </div>
                <img class="frame frame_end mt-2" src="assets/images/logout/frame.svg" alt="frame" />
            </div>
        </div>
    </div>
</ng-container>